import { stack as d3_stack } from 'd3-shape'
import { convertRowsToData } from '../utils/dataUtils'

export default function LineChartDataController(rows, config = {}) {
  let headers = rows[0]
  let propperHeaders = ['id', ...headers.slice(1)]

  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 2)
  rows.slice(1).forEach((row, i) => {
    row.interpolations.forEach((val, j) => {
      data[i].value[j].interpolated = val
    })
  })

  if (config.mode === 'areas') {
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let objArray = data.map(layer => {
      let res = { id: layer.id }
      layer.value.forEach(dd => {
        res[dd.id] = dd.value
      })
      return res
    })
    let stack = d3_stack()
      .value((d, key) => d[key])
      .keys(keys)

    let stacked = stack(objArray)
    let result = stacked.map(layer => {
      return {
        id: layer.key,
        index: layer.index,
        value: layer.map(dd => {
          return {
            id: dd.data.id,
            value: dd.data[layer.key],
            y0: dd[0],
            y1: dd[1],
            layerIndex: layer.index,
            isLastLayer: keys.indexOf(layer.key) === keys.length - 1,
            isFirstLayer: keys.indexOf(layer.key) === 0,
            parentId: layer.key,
          }
        }),
      }
    })
    return result
  } else {
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)
    let res = keys.map(key => {
      return {
        id: key.id,
        label: key.label,
        value: data.map(dd => {
          let cand = dd.value.find(ddd => ddd.id === key)
          return {
            id: cand.parentId,
            parentId: cand.id.id,
            label: cand.id.label,
            value: cand.value,
            interpolated: cand.interpolated,
          }
        }),
      }
    })
    return res
  }
}
